import { initials, avatarStyle } from '../../utils/helpers';

export const Avatar = ({ name, size = 'md', style: extraStyle = {} }) => {
  const { bg, color } = avatarStyle(name);
  const sz = size === 'sm' ? 30 : size === 'lg' ? 52 : 38;
  const fs = size === 'sm' ? 11 : size === 'lg' ? 20 : 14;
  return (
    <div className="avatar" style={{ width: sz, height: sz, minWidth: sz, fontSize: fs, background: bg, color, borderRadius: size === 'lg' ? 14 : '50%', ...extraStyle }}>
      {initials(name)}
    </div>
  );
};
